import DroppableView from '../../droppable/Droppable.view';
import { useCanvasController } from '../Canvas.controller';
import TemplateView from '../../template/Template.view';
import DraggableView from '../../draggable/Draggable.view';
import type CanvasProperties from '../Canvas.properties.ts';

export default function CanvasMobileView(props: CanvasProperties) {
  const { handleRightClickOpenDetails } = useCanvasController(props);

  return (
    <div>
      <DroppableView id="droppable-container">
        {props.marketComponents &&
          props.marketComponents.map((marketComponent, index) => (
            <DraggableView
              key={index}
              id={marketComponent.id?.toString() ?? '0'}
              marketComponentDetails={marketComponent}
              disabled={true}
            >
              <TemplateView
                marketComponent={marketComponent}
                onClickOpenDetails={(event) => handleRightClickOpenDetails(event, marketComponent)}
              />
            </DraggableView>
          ))}
      </DroppableView>
    </div>
  );
}
